import { AgGridAngular } from 'ag-grid-angular';
import { ColDef, ColGroupDef } from 'ag-grid-community';
import { Component, OnInit , ViewChild} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UserserviceService } from '../userservice.service';
import { ViewApplicationStatusDetailsComponent } from '../view-application-status-details/view-application-status-details.component';
//certificate
import { DatePipe } from '@angular/common'

import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
// import pdfMake from "pdfmake/build/pdfmake";
// import pdfFonts from "pdfmake/build/vfs_fonts";
// import pdfMake  from 'pdfmake/build/pdfmake.js';
// import pdfFonts from 'pdfmake/build/vfs_fonts.js';
(<any>pdfMake).vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-updaterequeststatus',
  templateUrl: './updaterequeststatus.component.html',
  styleUrls: ['./updaterequeststatus.component.scss']
})
export class UpdaterequeststatusComponent implements OnInit {
  @ViewChild('agGrid') agGrid!: AgGridAngular;
  allfeesdata: any;
  submitted = false;
  showtable: boolean=false;
  rowData:any;
  allrequests: any;
  norecords!: boolean;
  application_id: any;
  chkdisabled:boolean=false;
  Requestform!: FormGroup;
  requestStatus:boolean=true;
  applicationStatus:boolean=true;
  paymentStatus:boolean=true;
  studData: any;
  paymentData: any;
  totalpaymentcount: any;
  proccessing:boolean=false;
  exam_month_year: any;
  standard: any;
  seat_no: any;
  phisicalcopycheck: any;
  paidstatuscheck:any;
  approvedstatuscheck:any;
  canchangeapplicationstatus!: boolean;
  canchangerequeststatus!: boolean;
  studexamname!: string;

  generateCertificatecheck: boolean=false;
  migration_certificate_no: any;
  showgeneratebutton!: boolean;
  showprintbutton!: boolean;
  cancleUpdate: boolean=false;
  ismigrationgenerated: boolean=true;;
  constructor( private service:UserserviceService ,public router: Router,private route: ActivatedRoute,private formBuilder: FormBuilder,public datepipe: DatePipe) { }
  public columnDefs: (ColDef | ColGroupDef)[] = [
    {headerName: 'Application Id',field: 'application_id', width: 140, sortable: true, filter: true, sort: 'desc' },
    {headerName: 'View',
          field: 'application_id',
          width: 85,
          cellRenderer:ViewApplicationStatusDetailsComponent,
          cellRendererParams: {
          clicked: (field: any) => {
            this.displayupdateStatus(field);
          }
        },
    },
    {headerName: 'Standard',field: 'standard', width: 140, sortable: true, filter: true },
    {headerName: 'Seat No',field: 'seat_no', width: 120, sortable: true, filter: true },
    {headerName: 'Student Name',field:'stud_name', width: 240, sortable:true, filter:true},
    {headerName: 'School Index',field:'school_name', sortable: true, filter: true}, 
    {headerName: 'Acadamic Year',field: 'exam_month_year', sortable: true, filter: true },
    {headerName: 'Request Status',field:'request_status', sortable: true, filter: true},
    {headerName: 'Payment Status',field: 'payment_status',  sortable: true, filter: true},
    {headerName: 'Submitted On',field:'application_create_date', sortable:true,filter:true},
    {headerName: 'Application Status',field:'application_status', sortable:true,filter:true}
    
    ];
    
public defaultColDef: ColDef = {
  // set the default column width
  width: 145,
  // make every column editable
 
  // make every column use 'text' filter by default
  filter: 'agTextColumnFilter',
  // enable floating filters by default
  
  // make columns resizable
  resizable: true,
  
};



  ngOnInit(): void {
    // if(sessionStorage.getItem('roleid')=="2"){      
      if(!sessionStorage.getItem("loggeduser") || sessionStorage.getItem("loggeduser")==null){
         this.router.navigate(['/boardadminlogin']);
        // sessionStorage.clear();
       }
       else  if(sessionStorage.getItem('roleid')=="1"){
        this.router.navigate(['/dashboard']);
      }
      this.Requestform  = this.formBuilder.group({
        rdoRequestStatus:new FormControl(''),
        rdoApplicationStatus:new FormControl(''),
        rdoPaymentStatus:new FormControl(''),
        remarkRequestStatus:[''],
        remarkApplicationStatus:[''],
        remarkPaymentStatus:[''],
        // rdoRequestStatus:['',Validators.required],
        // remarkRequestStatus:['',Validators.required],
        // rdoApplicationStatus:['',Validators.required],
        // remarkApplicationStatus:['',Validators.required],
        // rdoPaymentStatus:['',Validators.required],
        // remarkPaymentStatus:['',Validators.required],
      })
      this.getallapplications();
  // }
     
  };
  get f() {return this.Requestform.controls; }

    onBtExport() {
      this.agGrid.api.exportDataAsCsv();
      // alert('fghjkl;bnk');
    }

    //get all request type
    getallapplications(){
      this.service.post('/Boardadmin_module/getallapplicationsfees',{}).subscribe((res:any)=>{
       // console.log(res.Data)
       if(res.status=="success"){
           this.allfeesdata=res.Data;         
          }
          else{
             alert("Something went wrong!, please refresh page.");
             window.location.reload();
          }
       });
    
    }
    //get request type
    getrequesttype(reqtype:any){
      // alert(reqtype.value)
          
          this.getappwiserequestdata(reqtype.value);
    }
    //get app type wise requests
    getappwiserequestdata(reqtype:any){
      
      let getstud: { application_type:any}={
        application_type: reqtype
      };
        this.service.post('/Boardadmin_module/fetch_all_student_applied_applicationwise',getstud).subscribe((res:any)=>{
          // console.log(res);
          if(res.status=="success"){
            this.showtable=true;
            this.allrequests=res.Data;
            this.rowData=[this.allrequests];
            // console.log(this.rowData);           
          }
          else{
            this.showtable=false;
            this.rowData=[];
          }
    });
    }
    displayupdateStatus(appid:any){
      this.application_id=appid;
      
      let getstud:{ app_id:any}={
        app_id: this.application_id
      };
        this.service.post('/Boardadmin_module/fetch_application_details_by_appid',getstud).subscribe((res:any)=>{
          if(res.status=="success"){
            this.studData=res.Data[0];
              
            if(this.studData){
               //set all values to radio buttons
               this.Requestform.patchValue({
                rdoRequestStatus: this.studData.request_status,
                rdoApplicationStatus:this.studData.application_status,
                rdoPaymentStatus:this.studData.payment_status,
                remarkRequestStatus:this.studData.request_status_remark,
                remarkApplicationStatus:this.studData.application_status_remark,
                remarkPaymentStatus:this.studData.payment_status_remark,
              });     
              //
              this.exam_month_year=this.studData.exam_month_year;
              this.standard=this.studData.standard;
              this.seat_no=this.studData.seat_no;
              this.generateCertificatecheck=false; 
              if(this.studData.physical_copy_checked=="" || this.studData.physical_copy_checked=="Not Received"){
                this.phisicalcopycheck=false;
                this.canchangerequeststatus=true;
                this.canchangeapplicationstatus=true;
                alert("Physical Copy not received for this application!");
              }
              else{
                this.phisicalcopycheck=true;
                this.canchangerequeststatus=false;
                this.canchangeapplicationstatus=false;
              }
              if(this.studData.payment_status=="Unpaid"){
                this.canchangeapplicationstatus=true;
                this.canchangerequeststatus=true;
                // this.showprintbutton=true;
              }
              if(this.studData.request_status=="Submitted"){
                this.canchangeapplicationstatus=true;
              }
              if( this.phisicalcopycheck==true && this.studData.payment_status=="Paid" && this.studData.request_status!="Submitted"){
                this.canchangerequeststatus=false;
                this.canchangeapplicationstatus=false;
              }
              if(this.studData.application_type=="Fresh_Migration_Certificate"){  
                // alert(this.studData.migration_certificate_no);
                this.generateCertificatecheck=true;        
                if(this.studData.migration_certificate_no!=""){
                  //certificate generated already  
                 this.ismigrationgenerated=true; 
                this.migration_certificate_no=this.studData.migration_certificate_no;
                this.canchangerequeststatus=true;
                this.showprintbutton=false;
                this.showgeneratebutton=true;
                  
                }
                //   else if(this.studData.request_status=="Approved"){
                  //     this.showgeneratebutton=true;
                  //     this.showprintbutton=false;
                  //   this.canchangerequeststatus=true;
                  // }
                else{
                //certificate not generated
                this.ismigrationgenerated=false;
                if(this.studData.request_status!="Approved"){
                      this.showgeneratebutton=true;
                      this.showprintbutton=true;
                    // this.canchangerequeststatus=false;
                  }
                  else{
                    this.showgeneratebutton=false;
                    this.showprintbutton=true;
                    // this.canchangerequeststatus=false;
                  }
              }
              }
            }          
        }
          else{
            this.studData="";
            alert("Page is having problem in loading, Please retry!")
            this.router.navigate(['/dashboard']);
            }
            
        });
        //get payment transactions of app_id
        this.service.post('/Boardadmin_module/fetch_all_payment_transactions_by_appid',getstud).subscribe((res:any)=>{
          if(res.status=="success"){
            this.paymentData=res.Data;
            this.totalpaymentcount=res.Data.length;
            // console.log(res.Data.length);    
          }
          else{
            this.paymentData="";
            this.totalpaymentcount=0;
            
            // alert("Page is having problem in loading, Please retry!")
            // this.router.navigate(['/dashboard']);
            }
            
        });
    }
    onSubmit(form:any ){
      this.submitted = true;
      if (this.Requestform.invalid) {
        alert("Please Fill All Details!");
        // this.findInvalidControls();
        return;
      }

      // else if(this.Requestform.value.rdoRequestStatus=="" ||this.Requestform.value.rdoRequestStatus==null){
      //   alert("Request status can not be blank, Please select Request status!!");
      //   return;
      // }
      // else if(this.Requestform.value.rdoPaymentStatus=="Unpaid" ||this.Requestform.value.rdoPaymentStatus==""||this.Requestform.value.rdoPaymentStatus==null){
      //   alert("Payment Status MUST be PAID To Update status!!!");
      //   return;
      // }
      // else{
      //   if(this.Requestform.value.rdoApplicationStatus==null){
      //     this.Requestform.patchValue({            
      //       rdoApplicationStatus:"",
      //     });   
      //   }
      // } 
           this.updateStudStatusDetails();
      
    } 
    updateStudStatusDetails(){
      let appstatusvalue=""
      if(this.Requestform.value.rdoApplicationStatus!=null){
        appstatusvalue=this.Requestform.value.rdoApplicationStatus;
      }
      if(this.Requestform.value.rdoPaymentStatus=="Unpaid"){
      let conf=confirm("Clicking on Ok will update following statuses for this application Id:  "+this.application_id+" ??\n Request Status:  "+this.studData.request_status+"\n Application Status:  "+appstatusvalue+"\n Payment Status:  "+this.Requestform.value.rdoPaymentStatus);
      if(conf==true){
        this.proccessing=true;      
          
                // rdoApplicationStatus:,
                // rdoPaymentStatus:this.studData.payment_status,
                // remarkRequestStatus:,
                // remarkApplicationStatus:,
                // remarkPaymentStatus:this.studData.payment_status_remark,
          let studdetail :{ app_id:any,request_status:any,application_status:any,payment_status:any,
            request_status_remark:any,application_status_remark:any,payment_status_remark:any}={
            app_id: this.application_id,
            request_status: this.studData.request_status,
            application_status: this.studData.application_status,
            payment_status: this.Requestform.value.rdoPaymentStatus,
            request_status_remark:this.studData.request_status_remark,
            application_status_remark:this.studData.application_status_remark,
            payment_status_remark:this.Requestform.value.remarkPaymentStatus,
          };
          this.service.post('/Boardadmin_module/update_status_by_appid',studdetail).subscribe((res:any)=>{
            // console.log(res);
            setTimeout(()=>{
           if(res.status=="success"){
               alert(res.Data+"\r\n ");
               this.proccessing=false;
              //  this.router.navigate(['/viewapplicationstatus'])
              //  window.location.reload();  
              this.displayupdateStatus(this.application_id);
           }
           else{
             this.proccessing=false;
             alert(res.Data);
           }
         },1000); 
        });
        this.cancleUpdate=false;
        }
        else{
          this.proccessing=false;
          this.cancleUpdate=true;
          return;
        }
      }//unpaid
        else{//paid
          let conf=confirm("Clicking on Ok will update following statuses for this application Id:  "+this.application_id+" ??\n Request Status:  "+this.Requestform.value.rdoRequestStatus+"\n Application Status:  "+appstatusvalue+"\n Payment Status:  "+this.Requestform.value.rdoPaymentStatus);
      if(conf==true){
        this.proccessing=true;
            let studdetail :{ app_id:any,request_status:any,application_status:any,payment_status:any,
              request_status_remark:any,application_status_remark:any,payment_status_remark:any}={
              app_id: this.application_id,
              request_status: this.Requestform.value.rdoRequestStatus,
              application_status: appstatusvalue,
              payment_status: this.Requestform.value.rdoPaymentStatus,
              request_status_remark:this.Requestform.value.remarkRequestStatus,
              application_status_remark:this.Requestform.value.remarkApplicationStatus,
              payment_status_remark:this.Requestform.value.remarkPaymentStatus,
            };
            this.service.post('/Boardadmin_module/update_status_by_appid',studdetail).subscribe((res:any)=>{
              // console.log(res);
              setTimeout(()=>{
             if(res.status=="success"){
                 alert(res.Data+"\r\n ");
                 this.proccessing=false;
                //  this.router.navigate(['/viewapplicationstatus'])
                //  window.location.reload();    
              this.displayupdateStatus(this.application_id);

             }
             else{
               this.proccessing=false;
               alert(res.Data);
             }
           },1000); 
          });
          this.cancleUpdate=false;
        }
        else{
          this.proccessing=false;
          this.cancleUpdate=true;
          return;
        }
        }
        
          

    }

    openmodal(mdl:any){
      let testmodal=document.getElementById(mdl);
      testmodal?.style.setProperty("display","block");
  }
  closemodal(mdl:any){
      let testmodal=document.getElementById(mdl);
      testmodal?.style.setProperty("display","none");
  }
  checkstatus(pay:any){
    // alert(pay.checked + pay.value);
    if(pay.checked==true && pay.value=="Paid" &&this.ismigrationgenerated==false){
        // alert("payment done")
        if(this.phisicalcopycheck==true){
            this.canchangeapplicationstatus=false;
            this.canchangerequeststatus=false;
        }
    }
    if(pay.checked==true && pay.value=="Unpaid"){
        // alert("payment not done")
        this.Requestform.patchValue({
          rdoRequestStatus: this.studData.request_status,
          rdoApplicationStatus:this.studData.application_status,
          remarkRequestStatus:this.studData.request_status_remark,
          remarkApplicationStatus:this.studData.application_status_remark,
        }); 

        this.canchangeapplicationstatus=true;
        this.canchangerequeststatus=true;
    }
    // if(pay.checked==true && pay.value=="Submitted"){
    //   this.canchangeapplicationstatus=true;
    // }else 
    if(pay.checked==true && pay.value=="Approved"){
        this.canchangeapplicationstatus=false;
        this.showgeneratebutton=false;
    }
    else{
      this.canchangeapplicationstatus=true;
      this.showgeneratebutton=true;
    }
  }
//certificate
generateCertificate(){
  
  // if(this.studData.request_status!="Approved"){
  //   alert("Please Update Request status as Approved first");
  //   return;
  // }
  // else{
    this.proccessing=true;
    this.Requestform.patchValue({
      rdoApplicationStatus:"Printed",
      rdoRequestStatus:"Approved",
    });
    this.updateStudStatusDetails();
      
    if(this.cancleUpdate==false){
    let c=confirm("Are you sure to generate "+this.studData.application_type.replace(/_+/g," ")+" for Application No: "+this.application_id+"?")
 if(c==true){
       
            let studdetail :{ app_id:any}={
              app_id: this.application_id
             };
            this.service.post('/Boardadmin_module/generate_migration_certificate',studdetail).subscribe((res:any)=>{
              // console.log(res);
              setTimeout(()=>{
             if(res.status=="success"){
             
                //  alert(res.Data+"\r\n ");
                 alert("Migration Certificate Generated Successfully!!");
                 this.migration_certificate_no=res.Data;
                 this.proccessing=false;
                 this.canchangerequeststatus=true;
                 this.showprintbutton=false;
                 this.showgeneratebutton=true;
                
                //  this.router.navigate(['/viewapplicationstatus'])
                //  window.location.reload();    
             }
             else{
               this.proccessing=false;
               alert(res.Data);
             }
           },1000); 
          });
        }
        else{
          this.proccessing=false;
          return;
        }
      }
      else{
        //  this.Requestform.patchValue({
        //         rdoRequestStatus: this.studData.request_status,
        //         rdoApplicationStatus:this.studData.application_status,
        //         rdoPaymentStatus:this.studData.payment_status,
        //         remarkRequestStatus:this.studData.request_status_remark,
        //         remarkApplicationStatus:this.studData.application_status_remark,
        //         remarkPaymentStatus:this.studData.payment_status_remark,
        //       });
        this.displayupdateStatus(this.application_id);
      }
    // this.generateapplicationPdf(); 
  // }  
  
}

generateapplicationPdf(){
if(this.studData.standard=="HSSC"){
      this.studexamname="Higher Secondary";
}
else if(this.studData.standard=="SSC"){
      this.studexamname="Secondary";          
}
const documentDefinition = { 
  info: {
    title: 'Migration Certificate of '+ this.studData.stud_name+'-'+this.application_id,
    author: 'GBSHSE',
    subject:'Migration Certificate of '+ this.studData.stud_name+'-'+this.application_id
    },
  footer: {
    
    columns: [
      // {  text: '\u200B\u200B \u200B\t\t\t\t\t:'+this.datepipe.transform(new Date(), 'dd/MM/yyyy'), 
      //    alignment: 'left' ,
      //    margin: [5, 0, 0, 50 ],
      // },
      // {  text: '['+this.migration_certificate_no+"]", 
      //    alignment: 'right' ,         
      // }
    ]
  },
  content: [
    // {
    //   text: 'Goa Board of Secondary and.Higher Secondary Education,',
    //   bold: true,
    //   fontSize: 18,
    //   alignment: 'center',
    //   margin: [0, 0, 0, 10]
    // },
    // {
    //   text: '(A Corporate Statutory Body Constituted by an Act of the State Legislature)',
    //   // bold: true,
    //   fontSize: 13,
    //   alignment: 'center',
    //   margin: [0, 0, 0, 7]
    // },
    // {
    //   text: 'Alto - Betim, Goa 403521',
    //   // bold: true,
    //   fontSize: 13,
    //   alignment: 'center',
    //   margin: [0, 0, 0, 7]
    // },
    // {
    //   text: 'Website: www.gbshse.gov.in                                              '+' email: sss-gbshse.goa@nir.in                                  ' + 'ph: (0832) 2417553' ,
    //    // bold: true,
    //   fontSize: 9,
    //   // alignment: 'center',
    //   margin: [0, 0, 0, 7]
    // },
    // {
    //   text: '..................................................................................................................................................................................................................' ,
    //    // bold: true,
    //   fontSize: 9,
    //   // alignment: 'center',
    //   margin: [0, 0, 0, 7]
    // },
    {
      
      text:[ '\u200BThis is to certify that ',
      {text: ''+this.studData.stud_name.toUpperCase(), bold: true},
      ' Examination Seat No. '+this.studData.seat_no+'   has passed the ',
      {text: ''+this.studexamname+' School Certificate', bold: true},
      ' Examination held by this Board in ',
      {text: ''+this.studData.exam_month_year, bold: true},    
      
    ],
     // bold: true,
     fontSize: 14,
    alignment: 'justify',
     lineHeight:2,
     margin: [35, 310, 25, 10],
    },
    // {
    //   text: '\u200BThis is to certify that '+ this.studData.stud_name.toUpperCase()+', Examination Seat No. '+this.studData.seat_no+'   has passed the '+ this.studexamname+' School Certificate Examination held by this Board in '+this.studData.exam_month_year+ '.',
    //    // bold: true,
    //   fontSize: 14,
    //   // alignment: 'center',
    //   lineHeight:2,
    //   margin: [35, 310, 5, 10]
    // },
    {
      text: '\u200BThere is no objection to the candidate\'s joining an institution recognised by the Board or affiliated to a University.' ,
       // bold: true,
      fontSize: 14,
      alignment: 'justify',
      lineHeight:2,
      margin: [35, 15, 25, 10]
    },     
    {  text: '\u200B\u200B \t\t\t\t'+this.datepipe.transform(new Date(), 'dd/MM/yyyy'), 
         alignment: 'left' ,
         margin: [15, 200, 0, 0],
      },   
  ]
};
// (pdfMake as any).createPdf(documentDefinition).open();
// (pdfMake as any).createPdf(documentDefinition).download('Migration Certificate of '+ this.studData.stud_name+'.pdf');
(pdfMake as any).createPdf(documentDefinition).open({defaultFileName:'Migration Certificate of '+ this.studData.stud_name+'.pdf'});
}
refreshPage(){
  window.location.reload();
}
  }